/**
 * Katalog misji V2 (PLAN-V2 §7.2 / §9).
 * Postęp kroków liczy klient; wypłata tylko serwer (POST /api/quests/complete).
 */

export type QuestGiver = 'misia' | 'lola' | 'kotek';

export type QuestDef = {
  id: string;
  namePl: string;
  iconTexture: string;
  sceneKey: string;
  /** Liczba kroków 1–3 (ikony / serduszka w UI). */
  steps: number;
  /** 5–10 zł w katalogu; serwer wypłaca stałą QUEST_REWARD_ZL. */
  rewardZl: number;
  giver: QuestGiver;
};

export const QUESTS: readonly QuestDef[] = [
  {
    id: 'cafe_cupcakes',
    namePl: 'Podaj 3 ciastka gościom',
    iconTexture: 'ico_quest_cupcake',
    sceneKey: 'Cafe',
    steps: 3,
    rewardZl: 8,
    giver: 'lola',
  },
  {
    id: 'school_blocks',
    namePl: 'Ułóż 3 klocki na półce',
    iconTexture: 'ico_quest_blocks',
    sceneKey: 'School',
    steps: 3,
    rewardZl: 8,
    giver: 'misia',
  },
  {
    id: 'stable_feed_horses',
    namePl: 'Nakarm oba koniki',
    iconTexture: 'ico_quest_hay',
    sceneKey: 'Stable',
    steps: 2,
    rewardZl: 8,
    giver: 'misia',
  },
  {
    id: 'wardrobe_try_hats',
    namePl: 'Przymierz 2 czapki',
    iconTexture: 'ico_quest_hat',
    sceneKey: 'Wardrobe',
    steps: 2,
    rewardZl: 8,
    giver: 'lola',
  },
  {
    id: 'house_feed_dog',
    namePl: 'Nakarm pieska z miski',
    iconTexture: 'ico_quest_bowl',
    sceneKey: 'House',
    steps: 1,
    rewardZl: 8,
    giver: 'kotek',
  },
  {
    id: 'pool_trampoline',
    namePl: 'Skocz z trampoliny do wody',
    iconTexture: 'ico_quest_splash',
    sceneKey: 'Pool',
    steps: 1,
    rewardZl: 8,
    giver: 'lola',
  },
  {
    id: 'garden_fish',
    namePl: 'Złów jedną rybkę',
    iconTexture: 'ico_quest_fish',
    sceneKey: 'Garden',
    steps: 1,
    rewardZl: 8,
    giver: 'misia',
  },
  {
    id: 'town_pet_cat',
    namePl: 'Pogłaszcz kotka na ulicy',
    iconTexture: 'ico_quest_cat',
    sceneKey: 'Town',
    steps: 1,
    rewardZl: 8,
    giver: 'kotek',
  },
  {
    id: 'park_ball',
    namePl: 'Kopnij piłkę 3 razy',
    iconTexture: 'ico_quest_ball',
    sceneKey: 'Park',
    steps: 3,
    rewardZl: 8,
    giver: 'lola',
  },
  {
    id: 'shop_try_on',
    namePl: 'Przymierz ubranko w sklepie',
    iconTexture: 'ico_quest_dress',
    sceneKey: 'Shop',
    steps: 1,
    rewardZl: 8,
    giver: 'misia',
  },
] as const;

export const QUEST_BY_ID: ReadonlyMap<string, QuestDef> = new Map(
  QUESTS.map((q) => [q.id, q]),
);

export function getQuestById(id: string): QuestDef | undefined {
  return QUEST_BY_ID.get(id);
}

export const QUEST_IDS = QUESTS.map((q) => q.id);
